module.exports = __webpack_public_path__ + "img/venuetwo-icon1.f2697837.png";